import Room from "./Room"
import { LicodeEvent, RoomEvent, StreamEvent } from "./Events"
import Stream from "./Stream"
import Logger from "./utils/Logger"
import adapter from "webrtc-adapter"

// import * as L from "./utils/L.Resizer";

const Erizo = {
  Room: Room.bind(null, undefined, undefined, undefined),
  LicodeEvent,
  RoomEvent,
  StreamEvent,
  Stream: Stream.bind(null, undefined),
  Logger
}
Logger.setLogLevel(0)
export default Erizo
// # sourceMappingURL=Erizo.js.map
